import { render } from "./AuthorizationActionButtons.vue?vue&type=template&id=70a93b03&scoped=true&ts=true"
import script from "./AuthorizationActionButtons.vue?vue&type=script&lang=ts"
export * from "./AuthorizationActionButtons.vue?vue&type=script&lang=ts"

import "./AuthorizationActionButtons.vue?vue&type=style&index=0&id=70a93b03&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a93b03"]])

export default __exports__